import React from "react";
import { useTranslation } from "react-i18next";
import { useBookDemo } from "../../../../hooks/useBookDemo";

export const Hero: React.FC = () => {
  const { t } = useTranslation();
  const openBookDemo = useBookDemo("landing_hero");

  return (
    <section id="hero" className="bg-landingPageBG pt-10 lg:pt-16 text-center px-5">
      <div className="pb-6 sm:pb-10 md:pb-16 max-w-[954px] mx-auto flex flex-col items-center">
        <h1 className="text-white text-[40px] md:text-[64px] leading-[50px] md:leading-[74px] font-semibold mb-6">
          {t("landing.hero.title")}
        </h1>
        <p className="text-white/80 max-w-[750px] mx-auto text-[16px] md:text-[18px] leading-[26px] tracking-[0.01em] font-normal">
          {t("landing.hero.subtitle")}
        </p>
        <div className="mt-6 sm:mt-10 flex flex-wrap items-center justify-center gap-4">
          <button 
            onClick={openBookDemo}
            className="w-full sm:w-fit px-5 h-14 bg-accent rounded-2xl flex items-center justify-center gap-2 text-white text-[18px] font-semibold leading-6 transition-all duration-200 hover:bg-accent/90 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(5,46,22,0.45)] active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
          >
            {t("landing.hero.cta")}
            <img
              src="/assets/button-arrow.svg"
              alt="arrow"
              width={20}
              height={20}
            />
          </button>
          {/* <button className="w-full sm:w-fit px-[22px] h-14 bg-white border border-[#D0D5DD] rounded-2xl text-secondary text-[18px] leading-6 font-semibold transition-all duration-200 hover:bg-gray-50 hover:border-accent hover:text-accent hover:-translate-y-0.5 hover:shadow-[0_10px_25px_rgba(15,23,42,0.18)] active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-primary">
            See Demo
          </button> */}
        </div>
      </div>
      <div className="w-full mx-auto">
        <img
          src="/assets/hero.png"
          alt="laptop"
          width={1144}
          height={1000}
          className="mx-auto"
        />
      </div>
    </section>
  );
};
